import { PublicClientApplication, InteractionRequiredAuthError } from '@azure/msal-browser';

const CLIENT_ID = process.env.REACT_APP_AAD_CLIENT_ID;
const TENANT_ID = process.env.REACT_APP_AAD_TENANT_ID;

export const msalConfig = {
    auth: {
        clientId: CLIENT_ID,
        authority: `https://login.microsoftonline.com/${TENANT_ID}`,
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
};

export const loginRequest = {
    scopes: [`api://${CLIENT_ID}/access_as_user`],
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Wrap fetch with bearer-token attachment; redirect to login if token can't be acquired silently.
// Returns undefined if a redirect was triggered (page is about to reload).
export async function authFetch(url, opts = {}) {
    const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
    if (!account) {
        await msalInstance.loginRedirect(loginRequest);
        return;
    }

    let accessToken;
    try {
        const result = await msalInstance.acquireTokenSilent({ ...loginRequest, account });
        accessToken = result.accessToken;
    } catch (e) {
        if (e instanceof InteractionRequiredAuthError) {
            await msalInstance.acquireTokenRedirect(loginRequest);
            return;
        }
        throw e;
    }

    return fetch(url, {
        ...opts,
        headers: {
            ...(opts.headers || {}),
            Authorization: `Bearer ${accessToken}`,
        },
    });
}
